var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vw100 h400"},[_c('img',{staticClass:"w-per100 h-per100",attrs:{"referrerpolicy":"no-referrer","src":_vm.getImageUrl(_vm.banner.image),"alt":"佰信纸业"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }